import {createReducer} from "redux-act";
import {SortColumnOrder, SortColumnType} from "modules/utils";
import {sortTable} from "modules/actions/riders_table";

export interface ITableSort {
	sort: SortColumnType;
	order: SortColumnOrder;
}
const defaultState = {
	sort: SortColumnType.Price,
	order: SortColumnOrder.DESC,
};

export const riders_table = createReducer<typeof defaultState>({}, defaultState).on(
	sortTable,
	(state, payload) => ({
		...state,
		...payload,
	})
);
